// AtlasBar.tsx — S1. Below 900px (no room for a fixed column): a "Talk to
// Atlas" bar, fixed at the bottom of every cockpit screen, that opens the
// same conversation as a sheet (AtlasSheet).
import './AtlasBar.css';

export interface AtlasBarProps {
  onOpen: () => void;
}

export function AtlasBar({ onOpen }: AtlasBarProps) {
  return (
    <button type="button" class="atlas-bar" onClick={onOpen}>
      <span class="atlas-bar__dot" aria-hidden="true" />
      Talk to Atlas
    </button>
  );
}
